<template>
  <div class="footer" v-html="content"></div>
</template>

<script>
import { pcinit } from "../webapi/api";
export default {
  name: "tsfooter",
  data() {
    return {
      content:null
    };
  },
  created() {
    this.init();
  },
  methods: {
    //初始化
    init() {
      this.$fetch
        .fetchData({
          url: pcinit,
          method:"GET"
        })
        .then(res => {
          let { data } = res;
          this.content = data.uc_foot
        })
        .catch(e => {
          this.toast("error", e.errMsg || "请求错误");
        });
    },
    //消息提示
    toast(type, msg) {
      this.$message({
        type: type,
        showClose: true,
        message: msg,
        offset: 50
      });
    }
  }
};
</script>


<style>
/* 
新添加的dom或v-html添加的虚拟dom，
在实际意义上是一个子组件，
vue中当我们给style设置了 scoped,
该样式就只针对当前组件生效，
样式不会渗透到子组件。 
*/

.mian_bottom{ background-color:#282d33; padding-top:60px;}
.mian_bottom .warp {width: 1200px;margin: 0 auto;}
.bottom_cont{ overflow:hidden}
.bottom_fl{ float:left}
.bottom_fl h3{ font-size:20px; color:#c3c8ce;}

.bottom_fl ul.guangw_ul{ overflow:hidden; margin:15px 0 25px 5px;}
.bottom_fl ul.guangw_ul li{ float:left; color:#454a50; font-size:12px; margin-right:10px;}
.bottom_fl ul.guangw_ul li a{ color:#c3c8ce; font-size:14px; padding-right:10px;}
.bottom_fl ul.guangw_ul li a:hover{ color:#fff;}

.bottom_fl span{ font-size:14px; color:#c3c8ce; padding-top:25px; display:block; line-height:24px; width:400px;}
.bottom_fl span a{color:#b8bdc9}
.bottom_fr{ float:right; overflow:hidden; width:350px;}
.btom_titebtn{ width:200px; float:left}
.btom_titebtn a{ width:130px; height:40px; line-height:40px; display:block; text-align:center; color:#fff;font-size:18px; border-radius:5px; float:right; position:relative}
.btom_titebtn a em{ padding-left:45px;}
.btom_titebtn a em:after{ background:url(/personal/static/img/dh_t.png) no-repeat; content:""; width:21px; height:21px; display:block; position:absolute;left: 25px;top: 10px;}
.btom_titebtn b{ font-size:14px; color:#c3c8ce; text-align:right; display:block; margin:15px 0; float:right; width:200px;}
.btom_titebtn span{ display:block; font-size:24px; font-weight:bold; color:#fff; float:right}
.ewm_img{ float:right; width:121px; margin-left:25px;}
.ewm_img img{ width:121px; height:122px; display:block}
.ewm_img b{ font-size:14px; text-align:center; color:#fff; display:block; padding-top:10px;}
.bottom_cont{ overflow:hidden; padding-bottom:40px;}
.hezhb_txt{font-size:14px; color:#5a5d60;height:42px; line-height:42px;}
.hezhb_txt em{ font-size:14px; color:#5a5d60; padding-right:30px; }
.hz_btn{ height:48px; line-height:48px; background-color:#1e2126; font-size:14px; color:#8c9094; text-align:center}
.btom_15{ margin-bottom:15px;}


.datails_tit.show{ position:fixed; top:0; margin-top:0; z-index:9; border-bottom:1px solid #ddd;-webkit-box-shadow:0 2px 3px rgba(0, 0, 0, .1);-moz-box-shadow:0 2px 3px rgba(0, 0, 0, .1);  box-shadow:0 2px 3px rgba(0, 0, 0, .1); }
.highlight{ display:inline-block !important;font-weight:bold;color:#ff453c;text-indent:0px !important; line-height:24px !important;}
.highlightAc{ color:#fff;background:#ff6060;}

.more{ height:42px; line-height:42px; text-align:center; width:100%;color:#999; font-size:12px; display:none}
.bdshare_dialog_box,.bdshare_dialog_bg{ display:none !important}
.lawyer_link ul{ overflow:hidden; padding-bottom:40px;}
.lawyer_link li{ float:left; color:#4a4a50; padding:0 5px; line-height:30px;}
.lawyer_link li a{ color:#c3c8ce; padding-right:10px; font-size:14px;}
.lawyer_link li a:hover{ color:#fff;}
.lawyer_link li em{ color:#c3c8ce; font-size:14px;}
.lawyer_link{ width:730px; margin-top:10px;}
.bottom_fl h3{ font-size:18px; color:#fff; margin-left:5px;}
.hz_btn {
  padding: 10px 0;
  background-color: #1e2126;
  font-size: 14px;
  color: #8c9094;
  text-align: center;
}
.hz_btn .warp {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.hz_btn .warp span {
  line-height: 24px;
  font-size: 12px;
}
.hz_btn .warp span a {
  color: #fff;
}


/* footer start */
.main_bottom {
  background-color:#30343E; 
  padding-top: 48px;
  line-height: 1;
  font-size: 14px;
}

.main_warp {
  width: 1176px;
  margin: 0 auto;
  height: auto;
  overflow: hidden;
}

.main_bottom-bottom {
  padding: 12px 0 24px;
  width: 100%;
  background: #282C33;
}

.main_bottom-bottom p {
  margin-top: 12px;
  text-align: center;
}

.main_bottom-bottom p span {
  color: #fff;
  opacity: .4;
}

.main_bottom-bottom p a {
  color: #fff;
  opacity: .4;
}

.main_bottom-bottom p a:hover {
  opacity: .8;
}

.warp__top {
  width: 100%;
  overflow: hidden;
}

.warp__top-l {
  padding-right: 42px;
  float: left;
  position: relative;
  width: 580px;
  overflow: hidden;
  box-sizing: border-box;
}

.warp__top-l::after {
  content: "";
  width: 1px;
  height: 100%;
  background-color: #fff;
  opacity: .1;
  position: absolute;
  right: 0;
  top: 0;
}

.common__label {
  float: left;
  margin-right: 90px;
}

.common__label:last-child {
  margin-right: 0;
}

.common__label-t {
  margin-bottom: 32px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}

.common__label-code {
  width: 110px;
  height: 110px;
}

.common__label-p {
  color: #fff;
  opacity: .4;
  font-size: 14px;
  margin-top: 16px;
}

.common__links {
  margin-bottom: 16px;
}

.common__links:last-child {
  margin-bottom: 0;
}

.common__links a {
  color: #fff;
  font-size: 14px;
  opacity: .4;
}

.common__links a:hover {
  opacity: .8;
}

.warp__top-r {
  padding-left: 55px;
  float: left;
}

.warp__top-line {
  margin-top: -2px;
  opacity: .2;
  background-color: #fff;
  width: 136px;
  height: 1px;
}

.warp__top-date,
.warp__top-contact {
  color: #fff;
  opacity: .4;
  font-size: 14px;
  font-weight: bold;
}

.warp__top-contact {
  margin-top: 10px;
}

.warp__top-date {
  margin-top: 16px;
}

.warp__top-phone {
  margin-top: 15px;
  color: #1476F9;
  font-size: 16px;
  font-weight: bold;
}

.warp__bottom {
  width: 100%;
  overflow: hidden;
  padding-bottom: 22px;
  margin-top: 48px;
}

.warp__bottom-con {
  width: 100%;
  float: left;
  margin-bottom: 8px;
}

.warp__bottom-label {
  float: left;
  color: #fff;
  opacity: .4;
}

.warp__bottom-con ul {
  float: left;
  width: 1106px;
}

.warp__bottom-con ul li {
  margin-bottom: 10px;
  float: left;
}

.warp__bottom-con ul li em {
  margin: 0 8px;
  color: #fff;
  opacity: .4;
}

.warp__bottom-con ul li a {
  color: #fff;
  opacity: .4;
}

.warp__bottom-con ul li a:hover {
  opacity: .8;
}
/* footer end */
</style>



// WEBPACK FOOTER //
// src/components/footer.vue